module.exports = __webpack_public_path__ + "assets/images/albom4.5c92631f.jpg";